<!-- Vertical Menu -->
@if (layout() === 'vertical') {
  @for (item of menu; track item) {
    <!-- section -->
    <!-- <li core-menu-vertical-section *ngIf="item.type == 'section' && currentUser?.roles.includes(item?.role[0])" [item]="item" class="navigation-header"></li> -->
    @if (item.type === 'section') {
      <li core-menu-vertical-section [item]="item" class="navigation-header"></li>
    }
    <!-- sub-menu item/collapsible of sections  -->
    <!-- <ng-container *ngIf="item.type == 'section'  && (currentUser?.roles.includes(item?.role[0]) || item?.role.includes(currentUser?.roles[0]) )"> -->
    @if (item.type === 'section') {
      @for (item of item.children; track item) {
        <!-- item | if openInNewTab set routerLink & routerLinkActive blank -->
        <!-- *ngIf="item.type == 'item' && item?.role[0] == currentUser?.roles[0]" -->
        <!-- <li
        core-menu-vertical-item
        *ngIf="item.type == 'item' && (currentUser?.roles.includes(item?.role[0]) || item?.role.includes(currentUser?.roles[0]) )"
        [item]="item"
        [ngClass]="{ disabled: item.disabled === true }"
        [routerLinkActive]="!item.openInNewTab ? 'active' : ''"
        [routerLinkActiveOptions]="{ exact: item.exactMatch || false }"
        > -->
        <li
          core-menu-vertical-item
          [item]="item"
          [ngClass]="{ disabled: item.disabled === true }"
          [routerLinkActive]="!item.openInNewTab ? 'active' : ''"
          [routerLinkActiveOptions]="{ exact: item.exactMatch || false }"
          >
          <span [routerLink]="item.openInNewTab ? [] : [item.url]" class="d-none"></span>
        </li>
        <!-- collapsible -->
        @if (item.type === 'collapsible') {
          <li
            core-menu-vertical-collapsible
            [item]="item"
            class="nav-item has-sub"
          ></li>
        }
      }
    }
    <!-- item -->
    <!-- <li
    core-menu-vertical-item
    *ngIf="item.type == 'item' && currentUser?.roles.includes(item?.role[0])"
    [item]="item"
    [ngClass]="{ disabled: item.disabled === true }"
    [routerLinkActive]="!item.openInNewTab ? 'active' : ''"
    [routerLinkActiveOptions]="{ exact: item.exactMatch || false }"
    > -->
    <li
      core-menu-vertical-item
      [item]="item"
      [ngClass]="{ disabled: item.disabled === true }"
      [routerLinkActive]="!item.openInNewTab ? 'active' : ''"
      [routerLinkActiveOptions]="{ exact: item.exactMatch || false }"
      >
      <span [routerLink]="item.openInNewTab ? [] : [item.url]" class="d-none"></span>
      <span></span>
    </li>
    <!-- collapsible -->
    <!-- <li core-menu-vertical-collapsible *ngIf="item.type == 'collapsible' && currentUser?.roles.includes(item?.role[0])" [item]="item" class="nav-item has-sub"></li> -->
    @if (item.type === 'collapsible') {
      <li core-menu-vertical-collapsible [item]="item" class="nav-item has-sub"></li>
    }
  }
}
<!--/ Vertical Menu -->

<!-- Horizontal Menu -->
@if (layout() === 'horizontal') {
  @for (item of menu; track item) {
    <!-- section -->
    <!-- <li core-menu-horizontal-collapsible *ngIf="item.type == 'section' && currentUser?.roles.includes(item?.role[0])" [item]="item" class="dropdown nav-item"></li> -->
    @if (item.type === 'section') {
      <li core-menu-horizontal-collapsible [item]="item" class="dropdown nav-item"></li>
    }
    <!-- item | if openInNewTab set routerLink & routerLinkActive blank -->
    <!-- <li
    core-menu-horizontal-item
    *ngIf="item.type == 'item' && currentUser?.roles.includes(item?.role[0])"
    [item]="item"
    [ngClass]="{ disabled: item.disabled === true }"
    [routerLinkActive]="!item.openInNewTab ? 'active' : ''"
    [routerLinkActiveOptions]="{ exact: item.exactMatch || false }"
    > -->
    <li
      core-menu-horizontal-item
      [item]="item"
      [ngClass]="{ disabled: item.disabled === true }"
      [routerLinkActive]="!item.openInNewTab ? 'active' : ''"
      [routerLinkActiveOptions]="{ exact: item.exactMatch || false }"
      >
      <span [routerLink]="item.openInNewTab ? [] : [item.url]" class="d-none"></span>
    </li>
    <!-- collapsible -->
    <!-- <li
    core-menu-horizontal-collapsible
    *ngIf="item.type == 'collapsible' && item?.role[0] == currentUser?.roles[0]"
    [item]="item"
    class="dropdown dropdown-submenu"
  ></li> -->
  <li
    core-menu-horizontal-collapsible
    [item]="item"
    class="dropdown dropdown-submenu"
  ></li>
}
}
<!--/ Horizontal Menu -->
